import { fetch, post } from '@/utils/axios'

export default {
    // 登录
    login: (data) => {
        return post('/member/guest/login', data)
    },
    // 发送验证码
    sendCode: (data) => {
        return post('/member/guest/sendCode', data)
    },
    // 注册
    register: (data) => {
        return post('/member/guest/register', data)
    },
    // 忘记密码
    forgetPassword: (data) => {
        return post('/member/guest/forgetPassword', data)
    },
    // 获取用户信息
    getMemberInfo: (params) => {
        return fetch('/member/info/getMemberInfo', params)
    },
    // 修改头像
    upMemberAvatar: (data) => {
        return post('/member/info/upMemberAvatar', data)
    },
    // 修改密码
    upMemberPassword: (data) => {
        return post('/member/info/upMemberPassword', data)
    },
    // 修改资金密码
    upFundPassword: (data) => {
        return post('/member/info/upFundPassword', data)
    },
    // 绑定手机
    bindPhone: (data) => {
        return post('/member/info/bindPhone', data)
    },
    // 绑定邮箱
    bindEmail: (data) => {
        return post('/member/info/bindEmail', data)
    },
    // 获取认证信息
    getMemberAuthInfo: (params) => {
        return fetch('/member/info/getMemberAuthInfo', params)
    },
    // 初级认证
    baseAuth: (data) => {
        return post('/member/info/baseAuth', data)
    },
    // 高级认证
    highAuth: (data) => {
        return post('/member/info/highAuth', data)
    },
    // 获取资产认证信息
    getMemberAuthAsset: (params) => {
        return fetch('/member/info/getMemberAuthAsset', params)
    },
    // 资产认证
    authAsset: (data) => {
        return post('/member/info/authAsset', data)
    },
    // 法币入金
    recharge: (data) => {
        return post('/Asset/recharge', data)
    },
    // 充币
    rechargeCurrency: (data) => {
        return post('/Asset/rechargeCurrency', data)
    },
    // 法币提现
    withdrawal: (data) => {
        return post('/Asset/withdrawal', data)
    },
    // 提币
    withdrawalCurrency: (data) => {
        return post('/Asset/withdrawalCurrency', data)
    },
    // 获取资产余额
    getAssetBalance: (params) => {
        return fetch('/Asset/getAssetBalance', params, { sim: true })
    },
    // 获取资产业务类型
    getAssetBusiness: (params) => {
        return fetch('/Asset/getAssetBusiness', params, { sim: true })
    },
    // 获取资产币种类型
    getAssetWalletCurrency: (params) => {
        return fetch('/Asset/getAssetWalletCurrency', params, { sim: true })
    },
    // 获取资金明细
    getAssetChangeLog: (params) => {
        return fetch('/Asset/getAssetChangeLog', params, { sim: true })
    },
    // 获取充值提现记录
    getRechargeWithdrawalLog: (params) => {
        return fetch('/Asset/getRechargeWithdrawalLog', params)
    },
    // 获取资产统计
    getPropertyInfo: (params) => {
        return fetch('/Asset/getPropertyInfo', params, { sim: true })
    },
    // 划转
    transfer: (data) => {
        return post('/Asset/transfer', data, { sim: true })
    },
    // 闪兑
    flashcash: (data) => {
        return post('/Asset/flashcash', data, { sim: true })
    },
    // 获取币种最新价格
    getCurrencyNewPrice: (params) => {
        return fetch('/Asset/getCurrencyNewPrice', params, { sim: true })
    },
    // 切换模拟交易初始化
    initSimTrade: (params) => {
        return fetch('/Asset/initSimTrade', params, { sim: true })
    },
    // 查询用户钱包地址列表
    getWalletAddressList: (params) => {
        return fetch('/WalletAddress/getWalletAddressList', params)
    },
    // 新增用户钱包地址
    addWalletAddress: (data) => {
        return post('/WalletAddress/addWalletAddress', data)
    },
    // 删除用户钱包地址
    delWalletAddress: (params) => {
        return fetch('/WalletAddress/delWalletAddress', params)
    },
    // 获取投资组合
    getCombination: (params) => {
        return fetch('/Balance/getCombination', params)
    },
    // 获取佣金明细记录
    getCommissionChangeLog: (params) => {
        return fetch('/Commission/getCommissionChangeLog', params)
    },
    // 佣金转出到余额
    transferOut: (data) => {
        return post('/Commission/transferOut', data)
    },
    // 获取邀请记录
    getInviteLog: (params) => {
        return fetch('/Commission/getInviteLog', params)
    },
}